import { BaseFormat, BaseFormatList } from '@celum/formats/domain';

import { BASE_FORMAT_SERVICE } from '../../services/base-formats.service';
import { createFormatStore } from '../format/format-store.factory';

export const BaseFormatStore = createFormatStore<BaseFormat, BaseFormatList>(BASE_FORMAT_SERVICE, 'BaseFormatStore');
